import { Button, ButtonProps, ButtonVariant } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";

type NextStepButtonProps = {
  inverted?: boolean;
} & ButtonProps;

const NextStepButton = (props: NextStepButtonProps) => {
  const { inverted, className, ...rest } = props;
  return (
    <Button
      fullWidth
      className={clsx("py-4 active:scale-90 transition-transform duration-500 ease-out", className)}
      variant={inverted ? ButtonVariant.TextBlack : ButtonVariant.PrimaryGray}
      id={inverted ? "custom-button_inverted" : "custom-button"}
      {...rest}
    />
  );
};

export default NextStepButton;
